/**
 * Entrada das rotas de privacidade (`03-endpoints-draft.md §5`).
 *
 * O rascunho do contrato não fixou corpo para `POST /clientes/{uuid}/anonimizar`.
 * Este módulo fixa **um** campo obrigatório, e a razão é de auditoria, não de
 * validação: a anonimização é irreversível, e um registro em `auditoria_log` que
 * diz *quem* e *quando* sem dizer *por que* não responde a pergunta que se faz
 * meses depois — "de onde veio este pedido?".
 */
import { z } from 'zod'

/** Mínimo de caracteres úteis da justificativa. Mesmo piso do RN-11. */
export const JUSTIFICATIVA_ANONIMIZACAO_MINIMO = 20
export const JUSTIFICATIVA_ANONIMIZACAO_MAXIMO = 500

/**
 * `POST /clientes/{uuid}/anonimizar`.
 *
 * `justificativa` deve carregar **protocolo, canal e data do pedido do titular** —
 * não o nome dele. O texto passa pela mesma redação aplicada ao histórico antes de
 * ir para a auditoria (RNF-66): um nome digitado aqui seria substituído por
 * marcador, e a trilha ficaria sem a referência que importa.
 */
export const schemaAnonimizarCliente = z.object({
  justificativa: z
    .string({ required_error: 'Descreva o pedido do titular que motiva a anonimização.' })
    .trim()
    .min(
      JUSTIFICATIVA_ANONIMIZACAO_MINIMO,
      `Descreva o pedido com ao menos ${JUSTIFICATIVA_ANONIMIZACAO_MINIMO} caracteres ` +
        '(canal, data e protocolo da solicitação).',
    )
    .max(JUSTIFICATIVA_ANONIMIZACAO_MAXIMO, 'Justificativa muito longa.'),
})

export type EntradaAnonimizarCliente = z.infer<typeof schemaAnonimizarCliente>
